var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLivecasino(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 420.822 420.822",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B06E53"
    },
    d: "M282.795,19.423c-14.806-15.354-98.614-31.329-144.767-6.58 c-56.755,30.434-81.431,156.283,19.741,250.052c0.142,0.132,26.321-6.58,26.321-6.58L282.795,19.423z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD7A3"
    },
    d: "M256.831,232.202h-0.358v-15.37h-92.124v15.354c0,15.042-0.063,31.392-13.161,41.282v147.354 h59.223c0,0,31.011,0,59.223,0V273.239C256.872,263.324,256.831,247.115,256.831,232.202z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EBF0"
    },
    d: "M309.116,282.635h-2.193c-25.787,0-38.352-7.039-44.514-17.052l-12.993,56.534h-78.008 l-12.993-56.534c-6.163,10.013-18.728,17.052-44.514,17.052h-2.193c-39.976,0-72.384,32.407-72.384,72.384v46.062 c0,10.902,8.838,19.741,19.741,19.741h135.028h32.638h135.028c10.903,0,19.741-8.839,19.741-19.741v-46.062 C381.499,315.043,349.092,282.635,309.116,282.635z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D0D7DC"
    },
    cx: 210.411,
    cy: 368.18,
    r: 6.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D0D7DC"
    },
    cx: 210.411,
    cy: 401.081,
    r: 6.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B06E53"
    },
    d: "M269.634,12.842l-46.062,250.052l32.902-46.062C326.115,165.835,356.001,12.842,269.634,12.842z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC88E"
    },
    d: "M263.054,302.376c2.401,0.655,4.563,1.004,6.58,1.174v-30.312 c-12.762-9.915-12.803-26.124-12.803-41.037h-0.358v-15.37H184.09l-19.741,6.58C177.509,238.218,217.814,290.038,263.054,302.376z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE1B2"
    },
    d: "M302.536,131.288c0,52.696-52.408,118.446-92.124,118.446s-92.124-65.75-92.124-118.446 s41.246-72.384,92.124-72.384S302.536,78.592,302.536,131.288z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B06E53"
    },
    d: "M223.572,26.003c-3.697,0-15.701,4.154-25.512,7.794l-0.809-1.214c0,0-1.354,1.064-3.698,2.908 c-5.457,2.072-9.462,3.672-9.462,3.672l1.539,2.566c-24.976,19.678-75.379,44.953-80.503,50.077 c-6.58,6.58,19.741,81.431,19.741,78.964c0-68.271,64.068-75.846,105.285-85.544c18.644-4.387,43.869-15.354,46.062-26.321 C278.408,47.937,230.152,26.003,223.572,26.003z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B06E53"
    },
    d: "M263.054,65.485c0,33.998,16.451,62.924,39.071,68.682c12.395,3.155,6.992-35.78,6.992-35.78 s-17.548-44.966-19.741-46.062c-2.193-1.097-19.741-39.482-19.741-39.482l-39.482,32.902L263.054,65.485z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE1B2"
    },
    d: "M292.735,131.889c10.767-2.468,17.821,2.805,17.821,13.161c0,13.709-14.479,47.296-29.701,26.321 S292.735,131.889,292.735,131.889z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D7DC"
    },
    d: "M210.411,312.349l-32.902,32.902l-46.062-65.102l15.326-15.326 c2.475-2.475,6.454-2.579,9.055-0.238L210.411,312.349z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D7DC"
    },
    d: "M210.411,312.349l32.902,32.902l46.062-65.102l-15.326-15.326 c-2.475-2.475-6.454-2.579-9.055-0.238L210.411,312.349z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545465"
    },
    d: "M223.572,332.09c0,3.619-2.961,6.58-6.58,6.58h-13.161c-3.619,0-6.58-2.961-6.58-6.58v-13.161 c0-3.619,2.961-6.58,6.58-6.58h13.161c3.619,0,6.58,2.961,6.58,6.58V332.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545465"
    },
    d: "M203.831,318.929l-36.89-15.81c-4.342-1.861-9.172,1.324-9.172,6.048v32.684 c0,4.724,4.83,7.909,9.172,6.048l36.89-15.81V318.929z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545465"
    },
    d: "M216.991,318.929l36.89-15.81c4.342-1.861,9.172,1.324,9.172,6.048v32.684 c0,4.724-4.83,7.909-9.172,6.048l-36.89-15.81V318.929z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545465"
    },
    d: "M113.9,282.635h-2.193c-9.298,0-18.155,1.817-26.321,5.01v133.177h85.544l-39.19-139.635 C126.622,282.107,120.758,282.635,113.9,282.635z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545465"
    },
    d: "M306.923,282.635h2.193c9.298,0,18.155,1.817,26.321,5.01v133.177h-85.544l39.19-139.635 C294.2,282.107,300.064,282.635,306.923,282.635z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivecasino);
export default __webpack_public_path__ + "static/media/live casino.a0087f5435b15caacb05e944de8b3dde.svg";
export { ForwardRef as ReactComponent };